import getBasePath from '../../../../../common/functions/api-resource';

const basePath = getBasePath('relatorio', 'exportacao_arquivo');

const relatorioActions = {
  verificaExistemRegistros: { method: 'POST', url: `${basePath}/planilha/organograma/validar` },
};

export default resource => resource(`${basePath}`, {}, relatorioActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/relatorio/organograma.js